/* Landing page behaviour. Two things only.

   1. Offer block tier selector.
      Shopify subscriptions are NOT a separate variant: they are the same
      variant plus a selling_plan id. The cart add must post BOTH id and
      selling_plan. Posting only the variant id creates a silent one-time
      order that looks like a subscription to nobody but the customer.

      ROSCA + state auto-renewal law: recurring terms are revealed only when
      the subscription tier is selected, immediately above the order button,
      and that tier is never pre-selected.

   2. Hero carousel dots. The scrolling itself is CSS scroll-snap, so the
      strip works with JS disabled; the dots are an enhancement. */
(function () {
  /* ---------- offer block ---------- */
  function wireOffer(form) {
    var vid = form.querySelector('.offer-vid');
    var plan = form.querySelector('.offer-plan');
    var terms = form.querySelector('.subterms');
    var tiers = form.querySelectorAll('.tier');
    var shot = form.parentNode.querySelector('.offerimg img');

    Array.prototype.forEach.call(tiers, function (tier) {
      tier.addEventListener('click', function () {
        Array.prototype.forEach.call(tiers, function (t) {
          t.classList.remove('on');
        });
        tier.classList.add('on');
        if (vid) vid.value = tier.getAttribute('data-vid') || '';
        if (plan) plan.value = tier.getAttribute('data-plan') || '';
        if (terms) terms.hidden = !tier.getAttribute('data-plan');
        // The shot follows the tier, so the choice is a picture not a number.
        var src = tier.getAttribute('data-img');
        if (shot && src) shot.src = src;
      });
    });
  }

  /* ---------- hero carousel ---------- */
  function wireCarousel(root) {
    if (root.dataset.wired) return;
    root.dataset.wired = '1';

    var track = root.querySelector('.carousel-track');
    var dots = root.querySelector('.carousel-dots');
    var slides = root.querySelectorAll('.carousel-track > figure');
    if (!track || !dots || slides.length < 2) return;

    Array.prototype.forEach.call(slides, function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'carousel-dot' + (i === 0 ? ' on' : '');
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    // Trackpads swipe; mice do not. Without arrows the strip reads as broken
    // on desktop, which is exactly how it looked in the preview.
    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'carousel-arrow carousel-prev';
    next.className = 'carousel-arrow carousel-next';
    prev.innerHTML = '&#8249;';
    next.innerHTML = '&#8250;';
    prev.setAttribute('aria-label', 'Previous image');
    next.setAttribute('aria-label', 'Next image');
    root.appendChild(prev);
    root.appendChild(next);

    function go(dir) {
      var i = Math.round(track.scrollLeft / track.clientWidth) + dir;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var buttons = dots.querySelectorAll('.carousel-dot');
    prev.hidden = true;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        Array.prototype.forEach.call(buttons, function (b, n) {
          b.classList.toggle('on', n === i);
        });
        prev.hidden = i <= 0;
        next.hidden = i >= slides.length - 1;
        ticking = false;
      });
    });
  }


  /* ---------- lightbox ----------
     Supplement buyers zoom to read the label. Every image on the page opens
     full-screen: gallery, hero carousel, and the pack shot in the buy box.
     One overlay, reused; built lazily so it costs nothing until first click. */
  var box = null;

  function openLightbox(src, alt) {
    if (!box) {
      box = document.createElement('div');
      box.className = 'lightbox';
      box.hidden = true;
      box.innerHTML = '<button type="button" class="lightbox-close" ' +
                      'aria-label="Close">&times;</button><img alt="">';
      box.addEventListener('click', closeLightbox);
      document.body.appendChild(box);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
    }
    var img = box.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    box.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!box) return;
    box.hidden = true;
    document.body.style.overflow = '';
  }

  function wireZoom() {
    var sel = '.gal img, .carousel-track img, .offerimg img';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (img) {
      if (img.dataset.zoom) return;
      img.dataset.zoom = '1';
      img.addEventListener('click', function (e) {
        e.preventDefault();
        // Ask the CDN for a bigger render than the one laid out on the page -
        // people zoom to read the label, so a 640px source defeats the point.
        var src = img.currentSrc || img.src;
        openLightbox(src.replace(/([?&]width=)\d+/, '$11600'), img.alt);
      });
    });
  }


  /* ---------- offer deadline ----------
     Counts to a FIXED moment set by the merchant and then removes itself.
     There is deliberately no "reset", no per-visitor cookie and no rolling
     window: a timer that restarts on refresh is the artefact a regulator can
     prove from the page itself, and 11 of 15 competitor pages assert urgency
     that nothing on the page actually demonstrates. This one either means
     something or it is not on screen. */
  function wireCountdown(el) {
    var ends = Date.parse(el.getAttribute('data-deadline'));
    if (isNaN(ends)) return;
    var out = el.querySelector('.bar-count-time');

    function tick() {
      var left = ends - Date.now();
      if (left <= 0) {
        el.hidden = true;              // deadline passed: it simply goes away
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      el.hidden = false;
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('form.offer-form'), wireOffer);
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-carousel]'), wireCarousel);
    wireZoom();
    Array.prototype.forEach.call(
      document.querySelectorAll('.bar-count'), wireCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
